import { render, staticRenderFns } from "./UserGrantRole.vue?vue&type=template&id=7374979a&"
import script from "./UserGrantRole.vue?vue&type=script&lang=js&"
export * from "./UserGrantRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports